import { render, staticRenderFns } from "./SortByMobile.vue?vue&type=template&id=05a5ff7c&scoped=true&"
import script from "./SortByMobile.vue?vue&type=script&lang=js&"
export * from "./SortByMobile.vue?vue&type=script&lang=js&"
import style0 from "./SortByMobile.vue?vue&type=style&index=0&id=05a5ff7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5ff7c",
  null
  
)

export default component.exports